import List from './containers/ListContainer';

export default List;
